<template>
  <div>
    <q-dialog 
      :visible="isVisible"
      title="重新核对"
      width="600px"
      :innerScroll="false"
      :offsetHeight="170"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm" size="small" label-width="100px">
        <el-form-item label="核对时间" prop="checkDate">
          <el-date-picker
            v-model="formData.checkDate"
            type="date"
            placeholder="请选择核对时间"
            value-format="yyyyMMdd"
          />
        </el-form-item>
      </el-form> 
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isShowAnewCheckDialog: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.isShowAnewCheckDialog
      },
      set(newVal) {
        this.$emit('update:isShowAnewCheckDialog',newVal)
      }
    },
  },
  data() {
    return {
      formData: {
        checkDate: "",
      },
      rules: {
        checkDate: [
          {required: true, message: '请选择核对时间', trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
      this.formData.checkDate = ''
    },
    onConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { checkDate } = this.formData
          this.$api.dataReport.unionOrderReVerify(checkDate)
            .then(res => {
              if (res.success) {
                this.$message.success("核对成功");
                this.onCancel()
                this.$emit('verifySuccess')
              }
            })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
